import React, { useCallback } from 'react';
import { useState, useMemo } from 'react';
import { FormGroup } from '@patternfly/react-core';
import SelectV2 from './SelectV2';
import _ from 'lodash';
import { useAuthService } from 'services/AuthService/AuthService';
import { privileges } from 'utils/types';

export const useOrgIdSelect = ({ onChange, label = true, neededPrivilege = null, isDisabled = false }) => {
  const { user } = useAuthService();
  const selectOptions = useMemo(() => {
    const tmp = _.map(user?.organizations, org => {
      if (!neededPrivilege) {
        return {
          value: org,
          text: org.displayName
        };
      }
      return _.includes(org.privileges, privileges.Any) || _.includes(org.privileges, neededPrivilege) ?
        {
          value: org,
          text: org.displayName
        } : null;
    });
    return _.compact(tmp);
  }, [neededPrivilege, user?.organizations]);

  const [_currentOrg, setCurrentOrg] = useState(null);

  const currentOrg = useMemo(() => {
    return _currentOrg ?? _.first(selectOptions)?.value;
  }, [_currentOrg, selectOptions]);

  const _onChange = useCallback((selection) => {
    setCurrentOrg(selection);
    onChange?.(selection);
  }, [onChange]);

  const renderOrgIdSelect = useCallback(() => {
    // if (_.size(selectOptions) === 1) {
    //   return null;
    // }

    const iteratee = _.iteratee('id');
    if (!label) {
      return (
        <SelectV2
          isLoading={user.isLoading}
          options={selectOptions}
          value={currentOrg}
          onChange={_onChange}
          iteratee={iteratee} />);
    }
    return (
      // TODO: translate
      <FormGroup label={'Initial Organization'} fieldId="organization">
        <SelectV2 isLoading={user.isLoading} options={selectOptions} value={currentOrg} onChange={_onChange} iteratee={iteratee} isDisabled = {isDisabled || (_.size(selectOptions) === 1)}/>
      </FormGroup>
    );
  }, [selectOptions, label, user.isLoading, currentOrg, _onChange, isDisabled]);

  return {
    renderOrgIdSelect,
    currentOrg,
    numberOfOrgs: _.size(selectOptions),
    availableOrgs: _.map(selectOptions, 'value')
  };
};
